import { render } from "./OrderDetailPage.vue?vue&type=template&id=083ed250"
import script from "./OrderDetailPage.vue?vue&type=script&lang=js"
export * from "./OrderDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__